import { GridCurveExt } from '@/classes/scenario/grid/GridCurveExt';
import { ScenarioGrid } from '@/dto/scenario/grid/ScenarioGrid';
import { DtoExt } from '@/classes/scenario/DtoExt';
import { GridComplexPricingExt } from '@/classes/scenario/grid/GridComplexPricingExt';
import { GridAvailability } from '@/dto/scenario/grid/GridAvailability';

export class ScenarioGridExt extends DtoExt {

  public static fromDto(dto: ScenarioGrid): ScenarioGridExt {
    return new ScenarioGridExt({
      hasDifferentAvailabilityAfter: dto.hasDifferentAvailabilityAfter,

      availabilityTypeBefore: dto.availabilityTypeRefBefore,
      averageGridConnectionHoursPerDayBefore: dto.averageGridConnectionHoursPerDayBefore,
      averageGridConnectionHoursPerDayBeforePercentage: dto.averageGridConnectionPercentagePerDayBefore,
      gridComplexAvailabilityBefore: dto.gridComplexAvailabilityBefore && GridComplexPricingExt.fromDto(dto.gridComplexAvailabilityBefore),
      calculatedCurveBefore: dto.calculatedCurveBefore && GridCurveExt.fromDto(dto.calculatedCurveBefore),

      availabilityTypeAfter: dto.availabilityTypeRefAfter,
      averageGridConnectionHoursPerDayAfter: dto.averageGridConnectionHoursPerDayAfter,
      averageGridConnectionHoursPerDayAfterPercentage: dto.averageGridConnectionPercentagePerDayAfter,
      gridComplexAvailabilityAfter: dto.gridComplexAvailabilityAfter && GridComplexPricingExt.fromDto(dto.gridComplexAvailabilityAfter),
      calculatedCurveAfter: dto.calculatedCurveAfter && GridCurveExt.fromDto(dto.calculatedCurveAfter),

      hasGridLimitation: dto.hasGridLimitation,
      limitPower: dto.limitPower,
      limitPercentage: dto.limitPercentage,
      hasGrid24: dto.hasGrid24
    } as any);
  }

  public hasGrid24: boolean | null = null;

  public hasDifferentAvailabilityAfter: boolean | null = null;

  // Before
  public averageGridConnectionHoursPerDayBefore: number | null = null;
  public averageGridConnectionHoursPerDayBeforePercentage: number | null = null;
  public availabilityTypeBefore: GridAvailability | null = null;
  public gridComplexAvailabilityBefore: GridComplexPricingExt | null = null;
  // After
  public averageGridConnectionHoursPerDayAfter: number | null = null;
  public averageGridConnectionHoursPerDayAfterPercentage: number | null = null;
  public availabilityTypeAfter: GridAvailability | null = null;
  public gridComplexAvailabilityAfter: GridComplexPricingExt | null = null;

  public calculatedCurveBefore: GridCurveExt | null = null; // PARTIALLY FED
  public calculatedCurveAfter: GridCurveExt | null = null; // PARTIALLY FED

  public hasGridLimitation: boolean | null = null;

  public limitPower: number | null = null;

  public limitPercentage: number | null = null;

  constructor(options?: Partial<ScenarioGridExt>) {
    super();
    if (options) {
      DtoExt.assignToThis(this, options);
    }
  }

  public toDto(): ScenarioGrid {
    return new ScenarioGrid({
      hasDifferentAvailabilityAfter: this.hasDifferentAvailabilityAfter,

      availabilityTypeRefBefore: this.availabilityTypeBefore,
      averageGridConnectionHoursPerDayBefore: this.averageGridConnectionHoursPerDayBefore,
      averageGridConnectionPercentagePerDayBefore: this.averageGridConnectionHoursPerDayBeforePercentage,
      gridComplexAvailabilityBefore: this.gridComplexAvailabilityBefore?.toDto(),
      calculatedCurveBefore: this.calculatedCurveBefore && this.calculatedCurveBefore.toDto(),

      availabilityTypeRefAfter: this.availabilityTypeAfter,
      averageGridConnectionHoursPerDayAfter: this.averageGridConnectionHoursPerDayAfter,
      averageGridConnectionPercentagePerDayAfter: this.averageGridConnectionHoursPerDayAfterPercentage,
      gridComplexAvailabilityAfter: this.gridComplexAvailabilityAfter?.toDto(),
      calculatedCurveAfter: this.calculatedCurveAfter && this.calculatedCurveAfter.toDto(),

      hasGridLimitation: this.hasGridLimitation,
      limitPower: this.limitPower,
      limitPercentage: this.limitPercentage,
      hasGrid24: this.hasGrid24
    });
  }
}
